// request
export const START_CHECKOUT_REQUEST = 'START_CHECKOUT_REQUEST';
export const FINISH_CHECKOUT_REQUEST = 'FINISH_CHECKOUT_REQUEST';

/** Begin  Checkout **/
/********************************
 * 
 *  mutations
 * 
 ********************************/
//init checkout
export const INIT_CHECKOUT_STATE = 'INIT_CHECKOUT_STATE';
//設定車籍
export const SET_CARPROFILE = 'SET_CARPROFILE';
export const SET_MOTORPROFILE = 'SET_MOTORPROFILE';
//設定旅遊條件
export const SET_TRAVELFILTER_FORM = 'SET_TRAVELFILTER_FORM';
//設定傷害條件
export const SET_ACCIDENTFILTER_FORM = 'SET_ACCIDENTFILTER_FORM';
//設定寵物條件 SET_PETFILTER_FORM ='SET_PETFILTER_FORM';
export const SET_PETFILTER_FORM = 'SET_PETFILTER_FORM';
//設定疫苗防疫條件
export const SET_VACCINEFILTER_FORM = 'SET_VACCINEFILTER_FORM';
//設定旅遊投保期間
export const SET_INSUPERIOD = 'SET_INSUPERIOD';
//設定保險基礎資料
export const SET_INSUTYPE = 'SET_INSUTYPE';
export const SET_INSUINFOS = 'SET_INSUINFOS';
//設定訂單訂購資訊(汽車/機車/旅平/傷害/寵物/疫苗防疫)
export const SET_CAR_CHECKOUT_INFO = 'SET_CAR_CHECKOUT_INFO';
export const SET_MOTOR_CHECKOUT_INFO = 'SET_MOTOR_CHECKOUT_INFO';
export const SET_TRAVEL_CHECKOUT_INFO = 'SET_TRAVEL_CHECKOUT_INFO';
export const SET_ACCIDENT_CHECKOUT_INFO = 'SET_ACCIDENT_CHECKOUT_INFO';
export const SET_PET_CHECKOUT_INFO = 'SET_PET_CHECKOUT_INFO';
export const SET_VACCINE_CHECKOUT_INFO = 'SET_VACCINE_CHECKOUT_INFO';  //20210530 Wen Add
//設定訂單真實試算結果
export const SET_CHECKOUT_QUOTE_OFCAR = 'SET_CHECKOUT_QUOTE_OFCAR';
export const SET_CHECKOUT_QUOTE_OFTRAVEL = 'SET_CHECKOUT_QUOTE_OFTRAVEL';
export const SET_CHECKOUT_QUOTE_OFACCIDENT = 'SET_CHECKOUT_QUOTE_OFACCIDENT';
export const SET_CHECKOUT_QUOTE_OFPET = 'SET_CHECKOUT_QUOTE_OFPET';
export const SET_CHECKOUT_QUOTE_OFVACCINE = 'SET_CHECKOUT_QUOTE_OFVACCINE';//20210530 Wen Add
//設定訂單的條款
export const SET_CHECKOUT_PRODPOLICIES = 'SET_CHECKOUT_PRODPOLICIES';
/********************************
 * 
 *  action
 * 
 ********************************/
//更新車籍
export const UPDATE_CARPROFILE_ACTION = 'UPDATE_CARPROFILE_ACTION';
export const GET_CARPROFILE_ACTION = 'GET_CARPROFILE_ACTION';
//更新旅遊條件
export const UPDATE_TRAVELFILTER_FORM_ACTION = 'UPDATE_TRAVELFILTER_FORM_ACTION';
//更新傷害條件
export const UPDATE_ACCIDENTFILTER_FORM_ACTION = 'UPDATE_ACCIDENTFILTER_FORM_ACTION';
//更新寵物險條件
export const UPDATE_PETFILTER_FORM_ACTION = 'UPDATE_PETFILTER_FORM_ACTION';
//更新疫苗險防疫險條件
export const UPDATE_VACCINEFILTER_FORM_ACTION = 'UPDATE_VACCINEFILTER_FORM_ACTION';  //20210530 Wen Add
//更新旅遊投保期間;
export const UPDATE_INSUPERIOD_ACTION = 'UPDATE_INSUPERIOD_ACTION';
//更新保險基礎資料
export const UPDATE_INSUINFO_ACTION = 'UPDATE_INSUINFO_ACTION';
export const UPDATE_INSUTYPE_ACTION = 'UPDATE_INSUTYPE_ACTION';
//更新訂單訂購資訊
export const UPDATE_CHECKOUT_INFO_OFCAR_ACTION = 'UPDATE_CHECKOUT_INFO_OFCAR_ACTION';
export const UPDATE_CHECKOUT_INFO_OFTRAVEL_ACTION = 'UPDATE_CHECKOUT_INFO_OFTRAVEL_ACTION';
export const UPDATE_CHECKOUT_INFO_OFACCIDENT_ACTION = 'UPDATE_CHECKOUT_INFO_OFACCIDENT_ACTION';
export const UPDATE_CHECKOUT_INFO_OFPET_ACTION = 'UPDATE_CHECKOUT_INFO_OFPET_ACTION';
export const UPDATE_CHECKOUT_INFO_OFVACCINE_ACTION = 'UPDATE_CHECKOUT_INFO_OFVACCINE_ACTION'; //20210530 Wen Add
//更新訂單真實試算結果
export const GET_CHECKOUT_QUOTE_OFCAR_ACTION = 'GET_CHECKOUT_QUOTE_OFCAR_ACTION';
export const GET_CHECKOUT_QUOTE_OFTRAVEL_ACTION = 'GET_CHECKOUT_QUOTE_OFTRAVEL_ACTION';
export const GET_CHECKOUT_QUOTE_OFACCIDENT_ACTION = 'GET_CHECKOUT_QUOTE_OFACCIDENT_ACTION';
export const GET_CHECKOUT_QUOTE_OFPET_ACTION = 'GET_CHECKOUT_QUOTE_OFPET_ACTION';
export const GET_CHECKOUT_QUOTE_OFVACCINE_ACTION = 'GET_CHECKOUT_QUOTE_OFVACCINE_ACTION';//20210530 Wen Add
//訂單付款
export const CHECKOUT_PAYMENT_ACTION = 'CHECKOUT_PAYMENT_ACTION';
/** End  Checkout **/



